module.exports = __webpack_public_path__ + "img/article_9_3.9c253e87.png";